import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Logger } from '@app/core';
import { FilterService } from '@progress/kendo-angular-grid';
import { CustomKendoFilter } from '@app/shared/kendo/custom-kendo-filter';

const log = new Logger('KendoCitySelectComponent');

@Component({
  selector: 'app-kendo-role-select',
  templateUrl: './kendo-role-select.component.html',
  styleUrls: ['./kendo-role-select.component.scss'],
})
export class KendoRoleSelectComponent extends CustomKendoFilter implements OnInit, OnChanges {
  @Input() field: string;

  constructor(private formBuilder: FormBuilder, filterService: FilterService) {
    super(filterService);
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      role_id: [null],
      role: [null],
    });
    const role = this.getObjectFromStorage(this.field, 'user-roles');

    if (role) {
      setTimeout(() => {
        this.form.patchValue({
          role: role,
          role_id: role.id,
        });
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // Изчиства формата
    // Използва се, за да чисти филтрите, когато се сетне null state на таблицата
    if (this.form && changes && changes.filter && !changes.filter.currentValue) {
      this.form.reset();
    }
  }

  onSelect(event: any) {
    CustomKendoFilter.pushObjectInStorage(event, 'user-roles');

    this.filter = this.removeFilter(this.field);

    const filters = [];
    if (event) {
      filters.push({
        field: this.field,
        operator: 'eq',
        value: event.id,
      });
    }

    const root = this.filter || {
      logic: 'and',
      filters: [],
    };

    if (filters.length) {
      root.filters.push(...filters);
    }
    this.filterService.filter(root);
    log.debug('filters', filters);
  }
}
